module.exports = __webpack_public_path__ + "img/8.7e801563.png";